import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Je nám líto, že článek nebyl užitečný. Dáte nám vědět, co bylo špatně?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Informace, které hledám, chybí',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Vyskytují se faktické chyby',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Některé otázky jsou nejasné',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Poskytněte nám nějaké informace a my tento článek vylepšíme.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Odeslat'
    }
  }
};
